"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _Services = require("../common_features/utility/Services");
var _ManageStoreComponent = _interopRequireDefault(require("../components/ManageStoreComponent"));
var _helper = require("../common_features/utility/helper");
var _reactRedux = require("react-redux");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _countriesReducer = require("../common_features/redux/reducers/countriesReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreManagement = () => {
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    users
  } = (0, _reactRedux.useSelector)(state => state.users);
  const {
    Organization,
    ServiceProvider
  } = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails;
    return state === null || state === void 0 ? void 0 : (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : _state$userDetails.data;
  });
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const pageSize = 10;
  const [row, setRow] = (0, _react.useState)(null);
  const [count, setCount] = (0, _react.useState)(0);
  const [headerSchema, setHeaderSchema] = (0, _react.useState)([]);
  const [selectedFilter, setSelectedFilter] = (0, _react.useState)({
    value: 'Select',
    key: 'all',
    title: 'Select'
  });
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [disabled, setDisabled] = (0, _react.useState)(true);
  const [search, setSearch] = (0, _react.useState)('');
  const [rowSelect, setRowSelect] = (0, _react.useState)([]);
  const [isDataLoading, setIsDataLoading] = (0, _react.useState)(true);
  const [bodySchema, setBodySchema] = (0, _react.useState)(null);
  const [allSelect, setAllSelect] = (0, _react.useState)(false);
  const [query, setQuery] = (0, _react.useState)('');
  const [removeUserModal, setRemoveUserModal] = (0, _react.useState)(false);
  const {
    countriesList
  } = (0, _reactRedux.useSelector)(state => state.countries);
  const dropdownListDispatcher = [{
    "title": "Select",
    "key": "all",
    value: 'Select'
  }, {
    "title": "Store Name",
    "key": "name",
    value: 'Store Name'
  }, {
    "title": "Address",
    "key": "address",
    value: 'Address'
  }, {
    "title": "Organization",
    "key": "organization",
    value: 'Organization'
  }];
  const dropdownList = [{
    "title": "Select",
    "key": "all",
    value: 'Select'
  }, {
    "title": "Store Name",
    "key": "name",
    value: 'Store Name'
  }, {
    "title": "Address",
    "key": "address",
    value: 'Address'
  }, {
    "title": "Status",
    "key": "invitationStatus",
    "value": "Status"
  }];
  const setRowSelected = rowId => {
    if (allSelect) {
      setAllSelect(false);
      setRowSelect([rowId]);
      return;
    }
    const resultArr = rowSelect.filter(arrObj => arrObj !== rowId);
    if (resultArr.length === (rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length)) resultArr.push(rowId);
    setRowSelect(resultArr);
  };
  const setAllSelected = flag => {
    setAllSelect(flag);
    setRowSelect([]);
    if (flag) {
      let data = bodySchema.filter(row => row.isActive === 'Active' || row.isActive === true);
      data = data.map(rowData => rowData.id);
      setRowSelect(data);
    } else {
      setRowSelect([]);
    }
  };
  const currentStoreSet = result => {
    const currentSelectedRow = row.filter(rw => rw.storeId === result.id)[0];
    dispatch((0, _storesReducer.currentStore)({
      storeId: result.id,
      data: currentSelectedRow
    }));
    navigate(_RoutePath.default.storeDetails.useLink);
  };
  const setDataValuesToState = async pageNo => {
    let params = {
      entity: "stores",
      limit: pageSize,
      pageNo: pageNo || currentPage,
      attribute: selectedFilter.key,
      query: query
    };
    await (0, _Services.searchStore)(params).then(data => {
      if (data.data.rows.length) {
        const rowBody = data.data.rows.map(row => {
          var _row$Organization;
          const address = (0, _helper.isJSON)(row.address) ? (0, _helper.bindAddress)(JSON.parse(row.address), countriesList) : row.address;
          return {
            id: row.storeId,
            name: row.isActive ? /*#__PURE__*/_react.default.createElement("span", {
              style: {
                fontWeight: 600,
                color: "#006E96",
                width: "100%"
              }
            }, row.name) : row.name,
            address: address,
            monitoredDate: row.monitoredDate ? (0, _helper.formatDateString)(new Date(row.monitoredDate)) : "",
            organization: row === null || row === void 0 ? void 0 : (_row$Organization = row.Organization) === null || _row$Organization === void 0 ? void 0 : _row$Organization.name,
            isActive: row.isActive ? 'Active' : 'Inactive'
          };
        });
        setSearch('');
        setCount(data.data.count);
        setRow(data.data.rows);
        setBodySchema(rowBody);
        setIsDataLoading(false);
      } else {
        setSearch('');
        setCount(data.data.count);
        setRow(data.data.rows);
        setBodySchema([]);
        setIsDataLoading(false);
      }
    }).catch(() => {
      setIsDataLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    if (selectedFilter.key === dropdownList[0].key) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedFilter]);
  (0, _react.useEffect)(() => {
    const clearBtn = document.querySelector('.ant-input-clear-icon');
    clearBtn.onclick = () => {
      setQuery('');
      setCurrentPage(1);
      console.log(query, currentPage);
      setSelectedFilter({
        title: 'Select',
        key: 'all',
        value: 'Select'
      });
    };
    setCurrentPage(1);
    return () => {
      clearBtn.onclick = null;
      setBodySchema([]);
    };
  }, [search]);
  (0, _react.useEffect)(async () => {
    await (0, _Services.getCountryList)().then(async res => {
      if (res.success) {
        const countries = res.data ? res.data.map(country => {
          return {
            code: country.code,
            title: country.name,
            key: country.name + country.code
          };
        }) : [];
        dispatch((0, _countriesReducer.countriesListData)(countries));
      }
    });
    switch (userInfo.userType) {
      case 4:
      case 6:
        setHeaderSchema([{
          name: "Store Name"
        }, {
          address: "Address"
        }, {
          isActive: "Status"
        }]);
        break;
      case 5:
      case 7:
        setHeaderSchema([{
          name: "Store Name"
        }, {
          address: "Address"
        }, {
          organization: "Organization"
        }]);
        break;
    }
    setDataValuesToState();
    return () => {};
  }, [userInfo.userType]);
  (0, _react.useEffect)(() => {
    (query.length === 0 || selectedFilter.key === 'all') && setDataValuesToState();
    return () => {
      return null;
    };
  }, [query]);
  const handlePageChange = pageNum => {
    setCurrentPage(pageNum);
    setDataValuesToState(pageNum);
    setAllSelect(false);
    setRowSelect([]);
    setIsDataLoading(true);
  };
  const cancelRemoveModal = () => {
    setRemoveUserModal(false);
  };
  const handleRemoveModal = () => {
    setRemoveUserModal(true);
  };
  const handleDeleteStores = async rowId => {
    const resultArray = rowSelect.filter(arrObject => arrObject !== rowId);
    let selectedStore = resultArray;
    setIsDataLoading(true);
    setRemoveUserModal(false);
    setAllSelect(false);
    await (0, _Services.deleteStores)(selectedStore).then(apiResp => {
      if (apiResp && apiResp.success) {
        setRowSelect([]);
        handlePageChange(1);
      } else {
        setRowSelect([]);
        alert("Something went wrong, please try again.");
      }
    }).catch(error => {
      console.log(error);
    });
  };
  const handleOnKeyPress = e => {
    console.log(e.key);
    if (e.key === "Enter") {
      setDataValuesToState();
    }
  };
  const handleSetInputVal = e => {
    if (e.target.value.length > 2 && selectedFilter.key === "all") {
      setSelectedFilter(dropdownList[0]);
    } else if (e.target.value.length <= 2 && ["all"].includes(selectedFilter.key)) {
      setSelectedFilter({
        title: 'Select',
        key: 'all',
        value: 'Select'
      });
    }
    setQuery(e.target.value);
  };
  const navigateToCreateStore = () => {
    navigate(_RoutePath.default.createStore.useLink);
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: " "
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_ManageStoreComponent.default, {
    userType: userInfo.userType,
    removeStore: userInfo.userType === 4 ? "Delete Store" : null,
    removeUserModal: removeUserModal,
    modalHeaderText: rowSelect && (rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length) === 1 ? "Are you sure you want to delete ".concat(rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length, " store?") : "Are you sure you want to delete ".concat(rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length, " stores?"),
    modalDetailText: "This will remove all associations within the store(s) as well.",
    modalDetailText2: "This cannot be undone.",
    positiveActionButtonTitle: (rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length) === 1 ? "Delete ".concat(rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length, " store") : "Delete ".concat(rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length, " stores"),
    negativeButtonActionTitle: "Cancel",
    handleResendInviteModal: handleDeleteStores,
    handleSetReInviteCancelModal: cancelRemoveModal,
    onClickRemove: handleRemoveModal,
    row: row,
    count: count,
    rowSelect: rowSelect,
    headerSchema: headerSchema,
    bodySchema: bodySchema,
    allSelect: allSelect,
    setRowSelected: setRowSelected,
    setSelectedFilter: setSelectedFilter,
    selectedFilter: selectedFilter,
    pageSize: pageSize,
    currentPage: currentPage,
    handlePageChange: handlePageChange,
    navigate: navigateToCreateStore,
    query: query,
    setQuery: handleSetInputVal,
    setSearch: setSearch,
    currentStoreSet: currentStoreSet,
    isDataLoading: isDataLoading,
    setDataValuesToState: setDataValuesToState,
    setIsDataLoading: setIsDataLoading,
    serachUserType: userInfo.serachUserType,
    users: users,
    subHeading: Organization !== null && Organization !== void 0 && Organization.name ? Organization === null || Organization === void 0 ? void 0 : Organization.name : ServiceProvider === null || ServiceProvider === void 0 ? void 0 : ServiceProvider.name,
    setAllSelected: setAllSelected,
    checkboxPosition: userInfo.userType === 4 ? 'left' : null,
    handleOnKeyPress: handleOnKeyPress,
    dropdownList: [4].includes(userInfo.userType) ? dropdownList : dropdownListDispatcher,
    disabled: disabled
  }))));
};
var _default = exports.default = StoreManagement;